<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i>生产管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form ref="searchform" :model="searchform" label-width="120px" @keyup.enter.native="search()">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="入库单编号" prop="receiptNo">
                                <el-input v-model.trim="searchform.receiptNo" style="width: 100%" clearable
                                    placeholder="请输入入库单编号" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="生产工单编号" prop="orderNo">
                                <el-input v-model.trim="searchform.orderNo" style="width: 100%" clearable
                                    placeholder="请输入收货编码" />
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="6">
                            <el-form-item label="生产子工单编号" prop="subOrderNo">
                                <el-input v-model.trim="searchform.subOrderNo" style="width: 100%" clearable
                                    placeholder="请输入生产子工单编号" />
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="6">
                            <el-form-item label="产品编码" prop="productCode">
                                <el-input v-model.trim="searchform.productCode" style="width: 100%" clearable
                                    placeholder="请输入产品编码" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="入库类型" prop="receiptType">
                                <el-select style="width: 100%;" v-model="searchform.receiptType" placeholder="请选择入库类型">
                                    <el-option label="生产入库" :value="1"></el-option>
                                    <el-option label="调拨入库" :value="2"></el-option>
                                    <el-option label="退货入库" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="状态" prop="status">
                                <el-select style="width: 100%;" v-model="searchform.status" placeholder="请选择状态">
                                    <el-option label="未确认" :value="0"></el-option>
                                    <el-option label="已确认" :value="1"></el-option>
                                    <el-option label="PDA已完成" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="入库日期" prop="datelist">
                                <el-date-picker style="width: 100%" v-model="searchform.datelist" type="daterange"
                                    value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
                                    range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                    :clearable='false'></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8" :offset="1">
                            <el-button @click="resetForm('searchform')">重置</el-button>
                            <el-button type="primary" icon="el-icon-search" v-permission="['receipt_select']"
                                @click="search()">搜索</el-button>
                            <el-button v-permission="['receipt_add']" type="primary" v-show="false"
                                @click="addOrder()">新增入库</el-button>
                            <!-- <el-button v-permission="['receipt_add']" type="primary"
                                @click="addOrder()">批量确定入库</el-button> -->
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <br id="A1" />
            <br />
            <el-row type="flex" class="row-bg">
                <el-col :span="24" class="border">
                    <h4>{{ $route.meta.title }}</h4>
                    <el-divider></el-divider>
                    <el-table ref="multipleTable" @select="selectSingleLine" @select-all="selectAllData" row-key="id"
                        show-summary :summary-method="getSummaries" border v-loading="listLoading"
                        element-loading-text="拼命加载中" :data="tableData" style="width: 100%" id="parent">
                        <el-table-column type="selection" width="55" :reserve-selection="true" />
                        <el-table-column prop="receiptNo" label="入库单编号" min-width="150" show-overflow-tooltip />
                        <el-table-column prop="orderNo" label="生产工单编号" min-width="150" show-overflow-tooltip />
                        <el-table-column prop="productName" label="产品名称" min-width="150" show-overflow-tooltip />
                        <!-- <el-table-column prop="scanQuantity" label="扫码数量" min-width="70" show-overflow-tooltip /> -->
                        <el-table-column prop="confirmQuantity" label="确认数量" min-width="70" show-overflow-tooltip />
                        <!-- <el-table-column prop="unitName" label="单位名称" min-width="70" show-overflow-tooltip /> -->
                        <!-- <el-table-column prop="warehouseName" label="仓库名称" min-width="150" show-overflow-tooltip /> -->
                        <el-table-column prop="receiptType" label="入库类型" min-width="80" show-overflow-tooltip>
                            <template slot-scope="scope">{{ receiptTypeList[scope.row.receiptType - 1] }}</template>
                        </el-table-column>
                        <el-table-column prop="receiptSource" label="单据来源" min-width="80" show-overflow-tooltip>
                            <template slot-scope="scope">{{ receiptSourceList[scope.row.receiptSource - 1]
                                }}</template>
                        </el-table-column>
                        <el-table-column prop="status" label="状态" min-width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.status == 0 ? '' : 'success'">{{
                                    statusList[scope.row.status] }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="receiptDate" label="入库日期" min-width="100" show-overflow-tooltip>
                            <template slot-scope="scope">{{ $parseTime(scope.row.receiptDate).slice(0, 10) }}</template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" min-width="140" show-overflow-tooltip>
                            <template slot-scope="scope">{{ $parseTime(scope.row.createTime) }}</template>
                        </el-table-column>
                        <!-- <el-table-column prop="boxCode" label="箱码" min-width="140" show-overflow-tooltip /> -->

                        <!-- <el-table-column min-width="240" property="actualProductCode" show-overflow-tooltip label="操作"
                            fixed="right">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.status === 0" v-permission="['receipt_updata']"
                                    type="primary" @click="updata(scope.row)">编辑</el-button>
                                <el-button v-if="scope.row.receiptSource != 3 && scope.row.status == 0"
                                    v-permission="['receipt_add']" type="primary"
                                    @click="confirm(scope.row)">确认入库</el-button>
                                <el-button v-if="scope.row.status === 0" v-permission="['receipt_delete']" type="danger"
                                    @click="deletedate(scope.row.id)">删除</el-button>
                            </template>
                        </el-table-column> -->
                    </el-table>
                    <br />
                    <el-pagination background @current-change="currentchange" @size-change="pagesize"
                        :current-page.sync="searchform.pageIndex" :page-sizes="[100, 200, 300, 400]"
                        layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
                </el-col>
            </el-row>
        </div>
        <receiptAdd ref="receiptAdd" />
    </div>
</template>
<script>
import { receiptList, receiptConfirm, receiptDelete } from "@/api/production";
import receiptAdd from "./components/receiptAdd";
//引入导出组件模块 
export default {
    components: { receiptAdd },
    mounted() {
        //请求部门列表数据并且便利到表格
        this.search();
    },
    data() {
        return {
            //基础数据
            listLoading: false,
            tableData: [],
            //分页数据
            pageSize: "",
            total_count: 0,
            receiptTypeList: ['生产入库', '调拨入库', '退货入库'],
            receiptSourceList: ['后台建单', 'PDA建单', '第三方系统同步',],
            statusList: ['未确认', '已确认', 'PDA已完成'],
            searchform: {
                pageSize: 100,
                pageIndex: 1,
            },
            allSelectedData: [],
        };
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.search()
        },
        //请求表格数据
        Tabledata(obj) {
            this.listLoading = true;
            this.searchform.receiptDateStart = this.searchform.datelist == null ? "" : this.searchform.datelist[0];
            this.searchform.receiptDateEnd = this.searchform.datelist == null ? "" : this.searchform.datelist[1];
            const data = JSON.parse(JSON.stringify(obj))
            console.log(data, 'data');

            receiptList(obj).then((response) => {
                this.tableData = response.data.items;
                this.total_count = response.data.total_count;
                this.searchform.pageIndex = response.data.page_index;
                this.listLoading = false;
            });
        },

        //搜索事件
        search() {
            this.searchform.pageIndex = 1;
            this.Tabledata(this.searchform);
        },
        //分页跳转事件
        currentchange(page) {
            this.searchform.pageIndex = page;
            this.Tabledata(this.searchform)
        },
        // 分页每页显示条数事件
        pagesize(page_size) {
            this.searchform.pageSize = page_size;
            this.search();
        },
        // 删除按钮事件
        deletedate(id) {
            this.$confirm("此操作将永久删除该入库单, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    receiptDelete({ id }).then((response) => {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.search();
                    });
                })
        },
        confirm(row) {
            this.$prompt('请填写入库数量', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPlaceholder: '请填写入库数量',
                inputValue: row.scanQuantity,
                inputValidator: (value) => {
                    if (!value) {
                        return '请填写取消原因';
                    }
                },
            }).then(({ value }) => {
                const parms = {
                    confirmQuantity: value,
                    id: row.id,
                    status: 1,
                }
                receiptConfirm(parms).then(res => {
                    this.$message({
                        type: 'success',
                        message: '取消成功!'
                    });
                    this.search()
                })
            })
        },
        addOrder() {
            this.$refs.receiptAdd.addData()
        },
        updata(row) {
            this.$refs.receiptAdd.addData()
            this.$refs.receiptAdd.getoutbilldata(row)
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (index === 4) {
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                    } else {
                        sums[index] = ' ';
                    }
                } else if (index === 5) {
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                    } else {
                        sums[index] = ' ';
                    }
                }
            });
            return sums;
        },
        selectSingleLine(selection, row) {
            if (row.status == 0) {
                if (this.allSelectedData.length) {
                    // 判断当前是选中数据还是取消选择
                    let index = this.allSelectedData.findIndex(item => item.id === row.id);
                    // 如果选中数据集中有此条信息，那么此次操作就是取消选中
                    index > -1 ? this.allSelectedData.splice(index, 1) : this.allSelectedData.push(row)
                } else {
                    this.allSelectedData.push(row);
                }
            } else {
                this.$message.error('请选择未确定单')
                // this.$refs.multipleTable.toggleRowSelection(row);
            }
        },
        // 全选表格
        selectAllData(arr) {
            // 全部选中当前表格数据
            if (arr.length) {
                const flag = arr.some(item => item.status !== 0);
                if (flag) {
                    this.$message.error('列表中有已确定单！');
                    this.$refs.multipleTable.clearSelection();
                    return
                }

                // 选中数据中已有数据
                if (this.allSelectedData.length) {
                    for (let i in arr) {
                        let index = this.allSelectedData.findIndex(item => item.id === arr[i].id);
                        // 如果不存在与选中数据集，就添加，否则跳过
                        if (index == -1) this.allSelectedData.push(arr[i]);
                    }
                } else {
                    arr.forEach(item => {
                        if (!this.allSelectedData.some(selected => selected.id === item.id)) {
                            this.allSelectedData.push(item)
                        }
                    });
                }
            } else {  // 取消全选
                // 需要判断当前表格数据与已选数据集是否一致，可能是搜索过后的表格，取消全选不能全部删除已选数据，需要逐一对比
                for (let i in this.tableData) {
                    let index = this.allSelectedData.findIndex(item => item.id === this.tableData[i].id);
                    if (index > -1) this.allSelectedData.splice(index, 1)
                }
            }
        },
    },
};
</script>